import React, { ReactElement, useContext } from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { UserContext, AuthState } from '../contexts/UserContext';

interface RequireAdminProps {
    children: React.ReactNode;
}

export function RequireAdmin({ children }: RequireAdminProps): ReactElement {
    const { user, authState } = useContext(UserContext);

    // Show loading while authentication is being determined
    if (authState === AuthState.Unknown || authState === AuthState.Initializing) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    // Show sign-in prompt if not authenticated
    if (authState === AuthState.SignedOut) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="warning">
                    You must be signed in to access the admin panel.
                </Alert>
            </Box>
        );
    }

    // Show access denied if user is authenticated but not admin
    if (authState === AuthState.SignedIn && !user?.isAdmin) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="error">
                    Access denied. You must be an administrator to access this page.
                </Alert>
            </Box>
        );
    }

    // User is authenticated and is admin - render the children
    return <>{children}</>;
}
